import { style, styleVariants } from "@vanilla-extract/css";
import { vars } from "../../styles/theme.css";

const listNotesIconBase = style({
  display: "block",
  width: "100%",
  height: "100%",
});

export const notesIcon = styleVariants({
  default: [
    listNotesIconBase,
    {
      color: vars.colors.onPrimaryFixed,
      fill: vars.colors.primaryFixed,
    },
  ],
  light: [
    listNotesIconBase,
    {
      color: vars.colors.onPrimary,
      fill: vars.colors.primary,
    },
  ],
});
